import { render } from "./EcommerceIcon.vue?vue&type=template&id=6c581de5"
import script from "./EcommerceIcon.vue?vue&type=script&lang=js"
export * from "./EcommerceIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/tantonj/Documents/GitHub/TantonSoftwareSolutions/tantonsoftwaresolutions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__